// Efeitos das notificações de ESTATUTO.
// Registrado em `constants/notificationHandlers.ts`.

import type { MapaDeHandlers } from '../../../constants/notificationHandlers';

/** O que o ESTATUTO le' da mensagem do WebSocket. */
export interface DadosWsEstatuto {
  estatuto_id?: number;
  kanban_card_id?: number;
  status?: string;
}

/**
 * `estatuto_assinatura` é push do webhook Autentique (estatuto_id,
 * kanban_card_id, status); os outros dois vêm do nosso fluxo. Os três terminam
 * no mesmo lugar — re-fetch do estatuto, da lista e do board —, porque a API é
 * a fonte da verdade e aqui só invalidamos cache.
 */
const recarregarEstatuto: MapaDeHandlers[string] = ({ message, queryClient }) => {
  const d = message.data;
  if (d.estatuto_id) {
    queryClient.invalidateQueries({ queryKey: ['estatuto', d.estatuto_id] });
  }
  queryClient.invalidateQueries({ queryKey: ['estatutos'] });
  queryClient.invalidateQueries({ queryKey: ['kanban-board'] });
};

export const HANDLERS_ESTATUTO: MapaDeHandlers = {
  estatuto_preenchido: recarregarEstatuto,
  estatuto_assinado: recarregarEstatuto,
  estatuto_assinatura: recarregarEstatuto,
};
